export const PAGE_API_QUERY_KEY_HEAD = 'page-api';
export const RECORD_DEPENDENT_API_QUERY_KEY_HEAD = 'records';
